import { Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './components/Login/Login';
import AdminPanel from './components/AdminPanel/AdminPanel';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Login/>}/>
            <Route path='/admin' element={<AdminPanel/>}/>


    </Routes>
  );
}

export default App;
